<div class="hero_area2">
    <app-menu [config]="config"></app-menu>
    <app-carrossel [config]="config"></app-carrossel>
</div>
<app-produtos-destaque [config]="config"></app-produtos-destaque>

<app-categorias-destaque [config]="config"></app-categorias-destaque>

